import React from "react"
  import {
    Container,
    Col,
    Row,
    Collapse,
    Navbar,
    NavbarToggler,
    NavbarBrand,
    Nav,
    NavItem,
    NavLink,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem } from 'reactstrap'
    import votinglogo from './images/votinglogo.png'
    import logowhite from './images/logowhite.png'
    import facebook from './images/facebook.png'
    import twitter from './images/twitter.png'
    import whatsapp from './images/whatsapp.png'

    function Header(){
          return (
            <Container fluid className="header">
              <Row className="text-center">
                <Col xs="8" className="text-left">
                <a href="#" target="_blank">
                    <img className="align-bottom" alt="Al Jazeera" width="100px" height="auto" src={votinglogo}/>
                  </a>
                  <a href="https://www.facebook.com/sharer/sharer.php?u=http%3A%2F%2Finteractive.aljazeera.com%2Faje%2F2019%2Fhow-the-world-votes-2019%2Findex.html" target="_blank">
                    <img className="align-bottom" style={{verticalAlign: "text-bottom", padding:"1px 5px"}} alt="Facebook" width="35px" height="auto" src={facebook}/>
                  </a>
                  <a href="https://twitter.com/intent/tweet?text=How the world votes: 2019 http%3A%2F%2Finteractive.aljazeera.com%2Faje%2F2019%2Fhow-the-world-votes-2019%2Findex.html" target="_blank">
                    <img className="align-bottom" style={{verticalAlign: "text-bottom", padding:"1px 5px"}} alt="Twitter" width="35px" height="auto" src={twitter}/>
                  </a>
                  <a href="whatsapp://send?text=How%20the%world%20votes%3A2019%20http%3A%2F%2Finteractive.aljazeera.com%2Faje%2F2019%2Fhow-the-world-votes-2019%2Findex.html" target="_blank">
                    <img className="align-bottom" style={{verticalAlign: "text-bottom", padding:"1px 5px"}} alt="Whatsapp" width="35px" height="auto" src={whatsapp}/>
                  </a>
                  {/* <a href="https://aljazeera.com" target="_blank">
                    <img alt="Al Jazeera" width="257px" height="auto" src={logobottom}/>
                  </a>
                  <br/>
                  <br/>
                  <br/>
                  <p>Developed by: <a href="https://twitter.com/ajlabs" target="_blank">@AJLabs</a></p>
                  <p>© 2019 Al Jazeera Media Network.</p> */}
                </Col>
                <Col xs="4" className="text-right">
                <a href="https://aljazeera.com" target="_blank">
                    <img alt="Al Jazeera" width="100px" height="auto" src={logowhite}/>
                  </a>
                </Col>
              </Row>
            </Container> 
          )
        }

export default Header